import posthog from "posthog-js";
import PropTypes from "prop-types";
import {useTranslation} from "react-i18next";
import {PrimaryButton, SecondaryButton} from "@/components/Button";
import {DownloadApp} from "../../../config/config";
import {useBrandTitle} from "../../../util/logoUtils";

const InstallationPrompt = ({deviceType, promptEvent, onClose}) => {
  const brandTitle = useBrandTitle();
  const {t} = useTranslation();

  const handleInstall = () => {
    if (deviceType === "android") {
      window.open(DownloadApp.ANDROID, "_blank");
      posthog.capture("install_android_button_clicked");
      onClose();
      return;
    }
    if (promptEvent) {
      promptEvent.prompt();
      posthog.capture(`install_${deviceType}_button_clicked`);
    }
    onClose();
  };

  return (
    <>
      <h2 style={{textAlign: "center"}}>{t("installPromptTitle", {brand: brandTitle})}</h2>
      <div style={{textAlign: "center"}}>
        {deviceType === "android" && (
          <p style={{color: "var(--text-primary)"}}>{t("installPromptAndroid", {brand: brandTitle})}</p>
        )}
        {deviceType === "ios" && (
          <p style={{color: "var(--text-primary)"}}>{t("installPromptIos", {brand: brandTitle})}</p>
        )}
        {deviceType === "desktop" && (
          <p style={{color: "var(--text-primary)"}}>{t("installPromptDesktop", {brand: brandTitle})}</p>
        )}
        <p style={{color: "var(--text-primary)"}}>{t("installPromptBenefit")}</p>

        <div
          style={{marginTop: "1rem", display: "flex", justifyContent: "center", alignItems: "center", gap: "0.5rem"}}
        >
          <PrimaryButton
            onClick={handleInstall}
            style={{borderRadius: "3px", minWidth: "120px", height: "44px"}}
          >
            {t("installPromptInstall")}
          </PrimaryButton>
          <SecondaryButton
            onClick={onClose}
            style={{
              border: "2px solid var(--text-secondary)",
              borderRadius: "3px",
              color: "var(--text-secondary)",
              minWidth: "120px",
              height: "44px",
            }}
          >
            {t("installPromptLater")}
          </SecondaryButton>
        </div>
      </div>
    </>
  );
};

InstallationPrompt.propTypes = {
  deviceType: PropTypes.string,
  promptEvent: PropTypes.object,
  onClose: PropTypes.func.isRequired,
};

export default InstallationPrompt;
